module.exports = __webpack_public_path__ + "35b5db9c708ece98f60a333419b731be.svg";